
import { getHtmlWrapper } from './svg_map_loader';

const SvgLoader = {
    getHtmlWrapper,
};

export default SvgLoader;
